import { createApp } from "vue";
import { createPinia } from "pinia";

import {
  defineCustomElementPnButton,
  defineCustomElementPnInput,
  defineCustomElementPnIcon,
  defineCustomElementPnSpinner,
  defineCustomElementPnCheckbox,
  defineCustomElementPnSelect,
  defineCustomElementPnRadioButton,
  defineCustomElementPnToast,
  defineCustomElementPnDatePicker,
  defineCustomElementPnTable,
  defineCustomElementPnFileUpload,
  defineCustomElementPnSearchField,
  defineCustomElementPnPagination,
  defineCustomElementPnTab,
  defineCustomElementPnTablist,
  defineCustomElementPnModal,
  defineCustomElementPnCard,
  defineCustomElementPnTag,
  defineCustomElementPnHeader,
  defineCustomElementPnProgressStepper,
  defineCustomElementPnFieldset,
  defineCustomElementPnToggleSwitch,
  defineCustomElementPnTextarea,
  defineCustomElementPnMultiselect,
  defineCustomElementPnAccordion,
  defineCustomElementPnAccordionRow,
  defineCustomElementPnActionMenu,
} from "@postnord/web-components/components";

defineCustomElementPnButton();
defineCustomElementPnInput();
defineCustomElementPnIcon();
defineCustomElementPnSpinner();
defineCustomElementPnCheckbox();
defineCustomElementPnSelect();
defineCustomElementPnRadioButton();
defineCustomElementPnToast();
defineCustomElementPnDatePicker();
defineCustomElementPnTable();
defineCustomElementPnFileUpload();
defineCustomElementPnSearchField();
defineCustomElementPnPagination();
defineCustomElementPnTab();
defineCustomElementPnTablist();
defineCustomElementPnModal();
defineCustomElementPnCard();
defineCustomElementPnTag();
defineCustomElementPnHeader();
defineCustomElementPnProgressStepper();
defineCustomElementPnFieldset();
defineCustomElementPnToggleSwitch();
defineCustomElementPnTextarea();
defineCustomElementPnMultiselect();
defineCustomElementPnAccordion();
defineCustomElementPnAccordionRow();
defineCustomElementPnActionMenu();

import App from "@/App.vue";
import router from "@/router";

const app = createApp(App);
app.use(createPinia());
app.use(router);

app.mount("#app");
